import { render } from "./UserCourses.vue?vue&type=template&id=4efc4243"
import script from "./UserCourses.vue?vue&type=script&lang=js"
export * from "./UserCourses.vue?vue&type=script&lang=js"

import "./UserCourses.vue?vue&type=style&index=0&id=4efc4243&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__